import { apiClient } from "./api";
import type { ColumnLayout } from "./tableColumns";

// Someone's own column layout of a list, kept on their account (services/api
// modules/tableLayouts). `layout` is null for the default, and unknown on the
// way in: it is whatever was stored, possibly by an older version of the screen
// — normalizeColumnLayout makes it fit today's columns.
export interface StoredTableLayout {
  table: string;
  layout: unknown;
  updatedAt: string | null;
}

// Per user: after a mock-mode sign-out the next person gets their own entry,
// not the cached layout of the one before.
export const tableLayoutKeys = {
  one: (userId: string, table: string) => ["tableLayouts", userId, table] as const,
};

export function getTableLayout(table: string): Promise<StoredTableLayout> {
  return apiClient.get<StoredTableLayout>(`/api/v1/table-layouts/${table}`);
}

// Replaces the stored layout wholesale; null returns to the default.
export function saveTableLayout(table: string, layout: ColumnLayout | null): Promise<StoredTableLayout> {
  return apiClient.put<StoredTableLayout>(`/api/v1/table-layouts/${table}`, { layout });
}
